import React, {
  createContext,
  useCallback,
  useContext
} from "react";
import CoinsView from "./CoinsView";

export type Currency = {
  silver: number;
  bg: number;
  gwz: number;
}

interface CoinContextValue {
  animateStatus: boolean;
  changeAnimationStatus: (value: boolean) => void;
}

export const CoinContext = createContext<CoinContextValue>({} as CoinContextValue);

interface CoinProviderProps {
  children: React.ReactElement;
}

const CoinProvider = ({ children }: CoinProviderProps) => {
  const [animateStatus, setAnimateStatus] = React.useState(false);

  const changeAnimationStatus = useCallback((value: boolean) => {
    setAnimateStatus(value);
  },[animateStatus]);

  return (
    <CoinContext.Provider value={{ animateStatus, changeAnimationStatus }}>
      {children}
      <CoinsView {...{ animateStatus }} />
    </CoinContext.Provider>
  );
};

export const useCoinContext = () => {
  return useContext(CoinContext);
};

export default CoinProvider;
